import { useState, useEffect, useMemo } from 'react';
import { 
  DgtPdOrderPicklistMovement
} from '../models'

import {
  getWasteReturnMovements
} from '../states/PicklistAction'

import { getDates } from '../utilities/Format'

export default function useWasteReturnMv(
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string
) : [ DgtPdOrderPicklistMovement[], (updatedMovement: DgtPdOrderPicklistMovement) => void] {
  const [ wasteReturns, setWasteReturns ] = useState<DgtPdOrderPicklistMovement[]>([]);

  const mutateWasteReturn = (updatedwasteReturn: DgtPdOrderPicklistMovement) => {
    setWasteReturns(wasteReturns.map(mv => mv.id === updatedwasteReturn.id ? updatedwasteReturn : mv))
  }

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo)
    Promise.allSettled(periodDates.map(date => {
      return getWasteReturnMovements(date)
    })).then(results => {
      const totalReturns = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklistMovement[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklistMovement[])
        setWasteReturns(totalReturns)
    })
    .catch(err => console.error(err))
  }, [ dateFrom, dateTo ]);

  const filteredReturns = useMemo(() => wasteReturns.filter(ex => ex.orderId.includes(searchByOrder)), [ searchByOrder, wasteReturns ])
  return [ filteredReturns, mutateWasteReturn ]
}